import React from 'react';
import UButton from "../UButton";

const UErrorPage = (props) => {

    return <div className="u_general-error">
        <div className="u_flex u_content-center">
            <img src={`/images/${props?.module ?? 'hrms'}.svg`} alt="Superworks"/>
        </div>
        <div className="u_general-error-content">
            <img src="/images/error-page.svg" alt="Superworks" className="u_mb-20"/>
            <h1 className="u_mb-20">{props?.title ?? "Oops! Something Went Wrong!"}</h1>
            <p className="u_mb-20" dangerouslySetInnerHTML={{__html: props?.description ?? "Please contact your system admin"}}></p>
            <div className="u_general-error-content-button">
                <UButton variant="white" type="Reload" onClick={() => window.location.reload(true)}/>
                {props?.module !== 'track' && !props?.isRedirectAccount && <UButton variant="white" type="Go to Workspace" onClick={() => window.location.href = `${process.env.REACT_APP_ACCOUNT_MODULE_URL}/workspace`}/>}
                {props?.module === 'track' && props?.isDownload && <UButton variant="blue" type="Download app" onClick={() => props?.onDownloadApp?.()} />}
                {props?.module !== 'track' && props?.isRedirectAccount && <UButton variant="white" type="Go to Account" onClick={() => props.onLogout()} />}
                <UButton variant="blue" type="Logout" onClick={() => props.onLogout()}/>
            </div>
        </div>
    </div>
}
export default UErrorPage;
